import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const PushingSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 25}
    height={props.height ? props.height : 24}
    fill="none"
    {...props}
  >
    <path fill="#F5F6F7" d="M6.078 9.375v-1.5h-3v1.5h3Zm-3 0V24h3V9.375h-3Z" />
    <path
      stroke="#F5F6F7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M19.578 22.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM4.578 7.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
    />
    <path
      stroke="#F5F6F7"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M16.578 19.5a12 12 0 0 1-12-12"
    />
  </svg>
)
export default PushingSVG
